import { FC } from 'react';

import { getCombinedLinkFieldValueHref } from '@common/link';
import { ComponentProps } from '@sitecore/types/lib';
import { SideNavRendering } from '@sitecore/types/SideNav';
import { StickyNav } from '@sparky';

type Props = ComponentProps & SideNavRendering;

const SideNav: FC<Props> = ({ fields }) => {
  const links = fields.items.map(item => ({
    active: item.active,
    href: getCombinedLinkFieldValueHref(item.fields.link.value),
    text: item.fields.link.value.text,
    target: item.fields.link.value.target,
  }));

  return <StickyNav links={links} />;
};

export default SideNav;
